export const damProduct = {
  name: 'Content Hub DAM',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Centralize all your digital assets and deliver them to any customer touchpoint with an automated DAM solution.',

  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: '$.annotations.URL',
          resource: 'tenant',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/17c794be8917427291c9630a8493fd15?v=4e74156e',
  },
  color: 'purple',
};
